<template>
    <a-modal :visible="true" :footer="null" @cancel="handleCancel" class="form-modal-v2">
        <div class="custom-modal-content">
            <div class="custom-modal-header">
                <div class="title">{{ title }}</div>
                <div v-if="subtitle" class="subtitle">{{ subtitle }}</div>
            </div>
            <div class="custom-modal-body">
                <slot name="body" />
            </div>
            <div class="custom-modal-footer">
                <slot name="footer" />
            </div>
        </div>
    </a-modal>
</template>
<script>
import log2 from "../utils/log2";
import Avatar from "vue-avatar";

const log = log2("PreferredAgentsFormModal");
import { mapGetters, mapState, mapActions } from "vuex";
import _ from "lodash";
import { sendSocketMessage } from "../utils/socketStream";

export default {
    name: "FormModal",
    props: {
        visitorId: {
            type: String,
            default: null,
        },
        value: {
            type: [Array, String],
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
        },
        showFooter: {
            type: Boolean,
            default: true,
        },
    },
    emits: ["cancel"],
    components: {
        Avatar,
    },
    methods: {
        handleCancel() {
            this.visibleModal = false;
            this.$emit("cancel");
        },
    },
};
</script>
<style lang="scss">
.ant-modal-root.form-modal-v2 {
    position: absolute;
    z-index: 9999999;

    .ant-modal-close-x {
        position: absolute;
        color: white;
        font-size: 20px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border-radius: 4px;

        &:hover {
            background: var(--color-bg-ghost-hover);
        }
    }

    .ant-modal-body {
        padding: 0 !important;
        font-size: 14px;
        font-weight: 400;
        color: var(--color-text-default);
        line-height: 24px;
    }

    .ant-modal-content {
        border-radius: 4px;
    }

    .custom-modal-content {
        display: flex;
        flex-direction: column;

        .custom-modal-header {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 20px;
            border-bottom: 1px solid var(--color-border-default);

            .title {
                font-weight: 700;
                color: var(--color-text-strong-default);
                font-size: 24px;
                line-height: 32px;
            }
        }

        .custom-modal-body {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 20px;
            background: var(--color-bg-neutral-default);
        }

        .custom-modal-footer {
            border-top: 1px solid var(--color-border-default);
            padding: 20px;
        }
    }
}
</style>
